import { useEffect, useState } from "react";
import { createGlobalStore } from "hox";
import { useReducer } from "react";
import { useRequest } from "ahooks";
import userServers from "@/services/userinfo";
import cookie from "@/utils/cookie";

export const [useUserInfo, getUserInfo] = createGlobalStore(() => {
  const [userinfo, setUserInfo] = useState({});

  const signUp = useRequest(userServers.signUp, {
    manual: true,
  });

  const { loading, runAsync } = useRequest(userServers.userinfo, {
    manual: true,
  });

  // 用户信息
  const getUserInfo = async () => {
    try {
      const res = await runAsync({
        payload: {},
      });
      if (res.code == 0) {
        setUserInfo(res.data);
        let { isShowKorean } = res.data;
        if (window.location.href.includes("ko_KR") && !isShowKorean) {
          cookie.write("lan", "en_US");
          window.location.href = "/en_US";
        }
      } else {
        if (window.location.href.includes("ko_KR")) {
          console.log(cookie.read("lan"));
          window.location.href = "/en_US";
        }
      }
    } catch (error) {
      if (window.location.href.includes("ko_KR")) {
        cookie.write("lan", "en_US");
        window.location.href = "/en_US";
      }
    }
  };

  const logoutFn = useRequest(userServers.logout, { manual: true });

  return {
    userinfo,
    userinfo_loading: loading,
    signUp,
    getUserInfo,
    logoutFn,
  };
});
